/**
 * Chain ID constants for blockchain networks
 */

export const CHAIN_IDS = {
  // Base (Coinbase L2)
  BASE: 8453,
} as const;
